import { Type } from 'class-transformer';

export interface IBillingSettingsData {
  id: string;
  billingSettings?: BillingSettings[];
}

export class BillingSettings {
  @Type(() => Date)
  validFrom?: Date;
  price?: number;
  basePrice?: number;
  collocationPrice?: number;
  remotegatePriceZa?: number;
  remotegatePriceBa?: number;
  servicePartnerCost?: number;
  cashback?: number;
  overcapacity?: number;
  cameraPrice?: number;
  undocumentedPenaltyEnabled?: boolean;
  @Type(() => Date)
  undocumentedPenaltyFrom?: Date | null;
  undocumentedPenalty?: number;
}
